import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Button from '@mui/material/Button';
import logo from "../assets/asetc/logo.png";
import "./styling/HeaderFooter.css";

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const showAdminButton = !location.pathname.includes('/admin'); // Hide button on admin pages

  return (
    <header className="main-header">
      <div className="header-content">
        <div className="header-left">
          <img src={logo} alt="Institute Logo" className="header-logo" />
          <div className="header-title-group">
            <h1 className="header-title">Aditya Skill & Educational Training Center</h1>
          </div>
        </div>
        {showAdminButton && (
          <Button 
            variant="outlined"
            onClick={() => navigate('/admin/login')}
            sx={{
              color: '#fff',
              borderColor: '#fff',
              '&:hover': {
                borderColor: '#fff',
                backgroundColor: 'rgba(255, 255, 255, 0.1)'
              }
            }}
          >
            Admin Login
          </Button>
        )}
      </div>
    </header>
  );
};

export default Header;
